export const GetAllLocationList=(isactive)=>{
    return $.get('Location/GetMinLocationDetails?IsActive='+isactive)
}
export const Createlocation=(loc)=>{
    return $.post('Location/AddLocation',loc)
}
export const UpdateLocation=(location)=>{
    return $.post('Location/UpdateLocation',location)
}
export const DeleteLocation=(locationid)=>{
    return $.post('Location/DeleteLocation?locationId='+locationid)
}
export const ChangeLocationStatus=(locationId,activeStatus)=>{
    return $.post('Location/LocationStatusChange?locationId='+locationId+'&activeStatus='+activeStatus)
}
export const GetStates = () => {
    return $.get('Location/GetStates')
  }


// WEBPACK FOOTER //
// ./src/pages/Administration/ManageLocation/managelocation.services.js